import config from '@/config/config'
import API_PATH from '@/constants/apiPath'
import GRAPH_TEMPLATES from '@/constants/graphTemplates'
import cloneDeep from 'lodash/cloneDeep'

const state = {
    cardsData: {
        shortenedUrls: 0,
        whitelistedUrls: 0,
        domainUrls: 0,
        subDomainUrls: 0
    },
    ctaTypePieChartOptions: {
        title: {
            top: '10px',
            text: 'Types of CTAs whitelisted',
            left: '5px',
            textStyle: {
                color: config.PRIMARY_TEXT_COLOR,
                fontWeight: 700,
                fontSize: 14
            }
        },
        tooltip: {
            trigger: 'item'
        },
        legend: {
            bottom: '15px',
            left: 'center',
            icon: 'circle'
        },
        grid: {},
        series: [
            {
                name: 'CTA type',
                type: 'pie',
                radius: '50%',
                data: [
                    { value: 1048, name: 'URL' },
                    { value: 735, name: 'Mobile' },
                    { value: 580, name: 'Email' }
                ],
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                },
                labelLine: {
                    show: false
                },
                label: {
                    show: false
                },
                color: config.CTATYPE_PIE_CHART_COLORS
            }
        ]
    },
    clickMetricsPieChartOptions: {
        title: {
            top: '10px',
            text: 'Clicks',
            left: '5px',
            textStyle: {
                color: config.PRIMARY_TEXT_COLOR,
                fontWeight: 700,
                fontSize: 14
            }
        },
        tooltip: {
            trigger: 'item'
        },
        legend: {
            bottom: '15px',
            left: 'center',
            icon: 'circle'
        },
        grid: {},
        series: [
            {
                name: 'Clicks',
                type: 'pie',
                radius: ['40%', '70%'],
                center: ['50%', '70%'],
                startAngle: 180,
                data: [
                    { value: 1048, name: 'Total Clicks' },
                    { value: 735, name: 'Unique Clicks' },
                    {
                        value: 1783,
                        itemStyle: {
                            // stop the chart from rendering this piece
                            color: 'none',
                            decal: {
                                symbol: 'none'
                            }
                        },
                        label: {
                            show: false
                        }
                    }
                ],
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                },
                labelLine: {
                    show: false
                },
                label: {
                    show: false
                },
                color: config.CLICKMETRICS_PIE_CHART_COLORS
            }
        ]
    },
    linkClicksBarChartOptions: {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        grid: {
            left: '20px',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01]
        },
        yAxis: {
            type: 'category',
            data: ['Link 1', 'Link 2', 'Link 3', 'Link 4', 'Link 5']
        },
        series: [
            {
                name: 'Clicks',
                type: 'bar',
                data: [0, 0, 0, 0, 0],
                color: ['#2F3043']
            }
        ]
    },
    clickTrendLineChartOptions: {
        xAxis: {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
            type: 'value'
        },
        series: [
            {
                data: [150, 230, 224, 218, 135, 147, 260],
                type: 'line',
                lineStyle: {
                    color: '#2F3043'
                },
                label: {
                    show: true
                }
            }
        ]
    },
    demographicChartOptions: cloneDeep(GRAPH_TEMPLATES.donutChartWithSideLegend),
    telcoChartOptions: cloneDeep(GRAPH_TEMPLATES.donutChartWithSideLegend),
    deviceChartOptions: cloneDeep(GRAPH_TEMPLATES.donutChartWithSideLegend),
    browserChartOptions: cloneDeep(GRAPH_TEMPLATES.donutChartWithSideLegend),
    emptyState: {
        demograph: false,
        telco: false,
        device: false,
        browser: false
    }
}

const getters = {
    getCardsData: (state) => state.cardsData,
    getCtaTypeMetrics: (state) => state.ctaTypePieChartOptions,
    getClickmetrics: (state) => state.clickMetricsPieChartOptions,
    getClickTrend: (state) => state.clickTrendLineChartOptions,
    getLinkClicks: (state) => state.linkClicksBarChartOptions,
    getDemographicClicks: (state) => state.demographicChartOptions,
    getTelcoClicks: (state) => state.telcoChartOptions,
    getDeviceClicks: (state) => state.deviceChartOptions,
    getBrowserClicks: (state) => state.browserChartOptions,
    getEmptyState: (state) => state.emptyState
}

const mutations = {
    POPULATE_WHITELISTED_ANALYTICS: (state, payload) => {
        state.cardsData.whitelistedUrls = payload[0].value
        state.ctaTypePieChartOptions.series[0].data = payload
    },
    POPULATE_SHORTENED_ANALYTICS: (state, payload) => {
        state.cardsData.shortenedUrls = payload.totalShortenedUrl
    },
    POPULATE_CLICKS_ANALYTICS: (state, payload) => {
        state.clickMetricsPieChartOptions.series[0].data = payload.allClicks
        if (payload.allClicksSum) {
            state.clickMetricsPieChartOptions.series[0].data.push({
                value: payload.allClicksSum,
                itemStyle: {
                    color: 'none',
                    decal: {
                        symbol: 'none'
                    }
                },
                label: {
                    show: false
                }
            })
        } else {
            state.clickMetricsPieChartOptions.series[0].data.push({
                value: 0,
                itemStyle: {
                    color: 'none',
                    decal: {
                        symbol: 'none'
                    }
                },
                label: {
                    show: false
                }
            })
            state.clickMetricsPieChartOptions.series[0].data.push({
                value: 0,
                itemStyle: {
                    color: 'none',
                    decal: {
                        symbol: 'none'
                    }
                },
                label: {
                    show: false
                }
            })
        }
    },
    POPULATE_CLICK_TREND: (state, payload) => {
        state.clickTrendLineChartOptions.xAxis.data = Object.keys(payload.clickTrends)
        state.clickTrendLineChartOptions.series[0].data = Object.values(payload.clickTrends)
    },
    POPULATE_LINK_CLICKS: (state, payload) => {
        if (payload.linkClicks.length) {
            state.linkClicksBarChartOptions.yAxis.data = []
            state.linkClicksBarChartOptions.series[0].data = []
            payload.linkClicks.forEach(item => {
                state.linkClicksBarChartOptions.yAxis.data.push(item.name)
                state.linkClicksBarChartOptions.series[0].data.push(item.value)
            })
        }
    },
    POPULATE_TYPE_CLICKS: (state, payload) => {
        if (payload.type === 'country' || payload.type === 'city' || payload.type === 'state') {
            if (payload.type === 'country') {
                state.demographicChartOptions.series[0].name = 'Country'
            } else if (payload.type === 'city') {
                state.demographicChartOptions.series[0].name = 'City'
            } else {
                state.demographicChartOptions.series[0].name = 'State'
            }
            if (payload.data.length) {
                state.emptyState.demograph = false
                state.demographicChartOptions.series[0].data = payload.data
                state.demographicChartOptions.legend.formatter = function (name) {
                    const dataItem = state.demographicChartOptions.series[0].data.find(item => item.name === name)
                    return name + ' - ' + dataItem.value
                }
            } else {
                state.emptyState.demograph = true
            }
        } else if (payload.type === 'telco') {
            if (payload.data.length) {
                state.emptyState.telco = false
                state.telcoChartOptions.series[0].name = 'Telecom'
                state.telcoChartOptions.series[0].data = payload.data
                state.telcoChartOptions.legend.formatter = function (name) {
                    const dataItem = state.telcoChartOptions.series[0].data.find(item => item.name === name)
                    return name + ' - ' + dataItem.value
                }
            } else {
                state.emptyState.telco = true
            }
        } else if (payload.type === 'browser' || payload.type === 'os') {
            if (payload.type === 'browser') {
                state.browserChartOptions.series[0].name = 'Browser'
            } else {
                state.browserChartOptions.series[0].name = 'OS'
            }
            if (payload.data.length) {
                state.emptyState.browser = false
                state.browserChartOptions.series[0].data = payload.data
                state.browserChartOptions.legend.formatter = function (name) {
                    const dataItem = state.browserChartOptions.series[0].data.find(item => item.name === name)
                    return name + ' - ' + dataItem.value
                }
            } else {
                state.emptyState.browser = true
            }
        } else {
            if (payload.type === 'device') {
                state.deviceChartOptions.series[0].name = 'Device'
            } else {
                state.deviceChartOptions.series[0].name = 'Device make'
            }
            if (payload.data.length) {
                state.emptyState.device = false
                state.deviceChartOptions.series[0].data = payload.data
                state.deviceChartOptions.legend.formatter = function (name) {
                    const dataItem = state.deviceChartOptions.series[0].data.find(item => item.name === name)
                    return name + ' - ' + dataItem.value
                }
            } else {
                state.emptyState.device = true
            }
        }
    }
}

const actions = {
    async fetchWhitelistAnalytics ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.analytics.whitelisted, payload)
            if (resp && resp.data) {
                commit('POPULATE_WHITELISTED_ANALYTICS', resp.data)
            }
        } catch (err) {
            console.log(err)
        }
    },
    async fetchShortenedAnalytics ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.analytics.shortened, payload)
            if (resp && resp.data) {
                commit('POPULATE_SHORTENED_ANALYTICS', resp.data)
            }
        } catch (err) {
            console.log(err)
        }
    },
    async fetchClicksAnalytics ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.analytics.clicks, payload)
            if (resp && resp.data) {
                commit('POPULATE_CLICKS_ANALYTICS', resp.data)
            }
        } catch (err) {
            console.log(err)
        }
    },
    async fetchClickTrendAnalytics ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.analytics.clicksTrend, payload)
            if (resp && resp.data) {
                commit('POPULATE_CLICK_TREND', resp.data)
            }
        } catch (err) {
            console.log(err)
        }
    },
    async fetchLinkAnalytics ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.analytics.links, payload)
            if (resp && resp.data) {
                commit('POPULATE_LINK_CLICKS', resp.data)
            }
        } catch (err) {
            console.log(err)
        }
    },
    async fetchTypeAnalytics ({ commit }, payload) {
        try {
            if (payload.type) {
                const resp = await this.$axios.post(API_PATH.analytics.typeClicks, payload)
                if (resp && resp.data) {
                    commit('POPULATE_TYPE_CLICKS', { data: resp.data, type: payload.type })
                }
            }
        } catch (err) {
            console.log(err)
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
